export default __webpack_public_path__ + "static/media/arrow_drop_down_gray.64a32373.svg";